import { AlertsTitle } from '../Alerts/style';
import Link from 'next/link';
import { get } from 'lodash';
import Switch from 'reusecore/src/elements/Switch';
import { dateFormat } from '../../helpers/dateHelper';
import icoCat from '@core/ui/static/images/ico-cat.svg';
import icoLocation from '@core/ui/static/images/ico-location.svg';
import icoCalendar from '@core/ui/static/images/ico-calendar.svg';
import { useTranslation } from 'next-i18next';
import { getAlertsUrl } from '../../helpers/urlHandler';

const RenderAction = ({ item, deleteAction }) => {
  const { t } = useTranslation();

  const { href } = getAlertsUrl(item.filter);
  return (
    <>
      <div className="actions">
        <Link href={href}>
          <a className="search">{t('profile.alerts.action.btn')}</a>
        </Link>
        {/*<Link>*/}
        {/*    <a>Modifier</a>*/}
        {/*</Link>*/}
        <a className="delete" onClick={() => deleteAction(item.id)}>
          {t('delete')}
        </a>
      </div>
    </>
  );
};
const RenderDate = ({ item }) => {
  const { t } = useTranslation();
  return (
    <>
      <span className="date">
        <img src={icoCalendar} alt={t('creationDate')} />{' '}
        {dateFormat(item.createdAt, t)}
      </span>
    </>
  );
};

const RenderNotification = ({ item, updateNotif }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="notif">
        <Switch
          switchSize="40px"
          switchColor="#00bcd4"
          isChecked={item.notifEmail}
          labelText={t('profile.alerts.notification.mail')}
          labelPosition="left"
          onChange={value => {
            const newItem = { ...item, notifEmail: value };
            updateNotif(newItem);
          }}
        />
      </div>
      <div className="notif">
        <Switch
          switchSize="40px"
          switchColor="#00bcd4"
          isChecked={item.notifMobile}
          labelText="Notification Mobile"
          labelPosition="left"
          onChange={value => {
            const newItem = { ...item, notifMobile: value };
            updateNotif(newItem);
          }}
        />
      </div>
    </>
  );
};

const renderTitle = item => {
  const { filter } = item;
  const extras = [];
  const total = get(item, 'posts.total', 0);
  const { href } = getAlertsUrl(filter);
  for (let i in filter) {
    if (i === 'category' || i === 'town') {
      extras.push(
        <span className={`${i} extra`} key={i}>
          <img
            src={i === 'category' ? icoCat : icoLocation}
            alt={i}
            style={{
              marginRight: '5px',
              marginTop: '2px',
              height: '13px',
            }}
          />
          {filter[i]}
        </span>
      );
    }
  }
  return (
    <>
      <AlertsTitle>
        <div className="top">
          <Link href={href}>
            <a>{item.title}</a>
          </Link>
          <span className="counter">{total}</span>
        </div>
        {extras.length > 0 && (
          <div className="bottom">{extras.map(extra => extra)}</div>
        )}
      </AlertsTitle>
    </>
  );
};

export { RenderAction, RenderDate, RenderNotification, renderTitle };
